import { render, staticRenderFns } from "./SubjectsItem.vue?vue&type=template&id=f8d12544&scoped=true"
import script from "./SubjectsItem.vue?vue&type=script&lang=js"
export * from "./SubjectsItem.vue?vue&type=script&lang=js"
import style0 from "./SubjectsItem.vue?vue&type=style&index=0&id=f8d12544&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d12544",
  null
  
)

export default component.exports